export const visit = (vm, at) => {
at({ "pl": { "conversationsVisitorUIAvailability": { "sameDay": "Wr\xF3cimy dzisiaj o {{time}}", "nextDay": "Wr\xF3cimy jutro o {{time}}", "nextWeek": "Powr\xF3t: {{dayOfWeek}} o {{time}}" } } });
};